export default "__VITE_ASSET__af3db66a__"